
import React, { Component } from 'react';
import { Fragment } from 'react';
class OriginComp extends Component {
    render() {
        return <div {...this.props}></div>;
    }
}
class RegisterCom extends Component {

    render() {
        let { component, visible, ...otherProps } = this.props;
        let ComponentTag = component ?? OriginComp;
        return (
            <Fragment>
                {visible && <ComponentTag {...otherProps} visible={visible} />}
            </Fragment>
        );
    }
}

export default RegisterCom;
